module.exports = __webpack_public_path__ + "static/img/contract.bbc4bf82.png";